import { render, staticRenderFns } from "./ScreenLaudoAxila.vue?vue&type=template&id=11daf3bf&lang=true&"
import script from "./ScreenLaudoAxila.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoAxila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports